import React, { FC, memo } from "react";
import { makeStyles } from "@mui/styles";
import { InputProps, TextField, Theme } from "@mui/material";
import { Clear } from "@mui/icons-material";
import TimePicker from "react-time-picker";

interface TextInputProps {
  required?: boolean;
  disabled?: boolean;
  label: string;
  fieldname: string;
  InputProps?: InputProps;
  inputProps?: InputProps["inputProps"];
  onChange?: (e: any) => any;
  value?: string;
}

const classes = {};

const TimeInput: FC<TextInputProps> = (props) => {
  const useStyles = makeStyles((theme: Theme) => ({
    root: {
      "& .react-time-picker__wrapper": {
        display: "flex",
        alignItems: "center",
        background: theme.palette.background.paper,
        border: "none",
        padding: "12px",
        "& .react-time-picker__inputGroup": {
          display: "flex",
          alignItems: "center",
          "& input": {
            border: "none",
            background: "none",
            fontFamily: "inherit",
            fontSize: "inherit",
            outline: "none",
            marginLeft: "1px",
            padding: 0,
            "&::placeholder": {
              color: theme.palette.text.disabled,
            },
          },
        },
        "& .react-time-picker__clear-button": {
          color: "grey",
        },
      },
      "& .MuiInputLabel-root": {
        transform: "translate(14px, 12px) scale(1)",
      },
      "& .MuiInputLabel-shrink": {
        transform: "translate(12px, -8px) scale(0.75)",
      },
      "& .MuiInput-formControl": {
        marginTop: "7px",
        "& .MuiInputBase-input": {
          height: "auto",
          padding: 0,
        },
      },
    },
  }));

  const { fieldname, onChange, value, label } = props;
  const classes = useStyles();

  return (
    <TextField
      fullWidth
      label={label}
      name={fieldname}
      className={classes.root}
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        disableUnderline: true,
        inputProps: {
          className: "react-time-picker__inputGroup__input",
          format: "HH:mm",
          disableClock: true,
          clearIcon: <Clear />,
        },

        // @ts-ignore
        inputComponent: TimePicker,
      }}
      onChange={onChange}
      value={value || ""}
    />
  );
};

export default memo(TimeInput);
